// ImportSuppliersButton.js

import React, { useState } from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import api from "../../services/api";
import { useCompany } from "../../context/CompanyContext";
import { useSnackbar } from "../../context/SnackbarContext";
import { Add as AddIcon } from "@mui/icons-material";

const ImportSuppliersButton = ({ onImportSuccess, children }) => {
  const [loading, setLoading] = useState(false);
  const { selectedCompany } = useCompany();
  const showSnackbar = useSnackbar();

  const handleImport = async () => {
    if (!selectedCompany) {
      showSnackbar("Please select a company before importing suppliers.", "error");
      return;
    }
    setLoading(true);
    try {
      const response = await api.post(`${process.env.REACT_APP_API_URL}/api/import_suppliers/`, {
        company_id: selectedCompany.id,
      });

      const result = response?.data;

      if (result?.success) {
        const importedCount = result?.importedCount || 0;

        if (importedCount > 0) {
          if (onImportSuccess) {
            onImportSuccess();
          }
        } else {
          showSnackbar("No new suppliers were imported.", "info");
        }
      } else {
        showSnackbar(`Error: ${result?.error || "Unknown error"}`, "error");
      }
    } catch (error) {
      console.error("Error importing suppliers:", error);
      showSnackbar("Import failed due to server error.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDButton onClick={handleImport} disabled={loading} variant="contained" color="info">
      {loading ? "Importing..." : children || "Import Suppliers"}
    </MDButton>
  );
};

// Define prop types
ImportSuppliersButton.propTypes = {
  onImportSuccess: PropTypes.func,
  children: PropTypes.node,
};

export default ImportSuppliersButton;
